angular.module('services.dialogs', [
            'services.dialogs.loginDialog',
            'services.dialogs.newInventoryDialog',
            'services.dialogs.inventoryCorrectionsModal',
            'services.dialogs.deliveryDocumentDownloadDialog',
            'services.dialogs.confirmationDialog',
            'services.dialogs.informationDialog',
            'services.dialogs.setFieldConfirmationDialog',
            'services.dialogs.deliveryConfirmationDialog',
            'services.dialogs.InvoiceConfirmationDialog',
            'services.dialogs.printInvoiceDialog',
            'services.dialogs.printPickingListDialog',
            'services.dialogs.printLanguageConfirmationDialog',
            'services.dialogs.printInventoryReportDialog',
            'services.dialogs.purchaseOrderAnalysisFilterDialog',
            'services.dialogs.salesTotalFilterDialog',
            'services.dialogs.updateOrderNoteDialog',
            'services.dialogs.labelPrintingDialog',
            'services.dialogs.updateAddressDialog',
            'services.dialogs.createVariantFulfillmentDialogService',
            'services.dialogs.createVariantDeliveryDateDialogService',
            'services.dialogs.importFinalizationDialog',
            'services.dialogs.colourChangeDialog',
            'services.dialogs.purchasePriceUpdateConfirmationDialog'
        ]);
